<template>
  <div>
    <px-view-header title="Indicadores de compras"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-indicadores-compras-header/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-totais-card :string-filter="stringFilter" card-height="360px"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-compras :string-filter="stringFilter"/>
        </v-col>

      </v-row>
      <v-row class="text-center align-center justify-center">
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-savings :string-filter="stringFilter"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-quantidade-compras :string-filter="stringFilter"
                                           chat-class="quantidade-chart-medium"/>
        </v-col>
      </v-row>
      <v-row class="text-center align-center justify-center">
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-compras-por-centro-custo :string-filter="stringFilter"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-compras-por-projeto :string-filter="stringFilter"/>
        </v-col>
      </v-row>
      <v-row class="text-center align-center justify-center">
        <v-col cols="12">
          <px-indicadores-listagem-compras id="lista-compras" :string-filter="stringFilter"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DashboardQuantidadeCompras from '@/modules/dashboard/DashboardQuantidadeCompras.vue';
import DashboardTotaisCard from '@/modules/dashboard/DashboardTotaisCard.vue';
import DashboardSavings from '@/modules/dashboard/DashboardSavings.vue';
import DashboardCompras from '@/modules/dashboard/DashboardCompras.vue';
import { mapGetters } from 'vuex';
import IndicadoresComprasHeader from '@/modules/indicadores-compras/IndicadoresComprasHeader.vue';
import DashboardComprasPorCentroCusto from './DashboardComprasPorCentroCusto.vue';
import DashboardComprasPorProjeto from './DashboardComprasPorProjeto.vue';
import IndicadoresListagemCompras from './lista-compra/IndicadoresListagemCompras.vue';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Compras' },
      ],
    };
  },
  computed: {
    ...mapGetters('indicadoresCompras', ['stringFilter']),
  },
  components: {
    pxDashboardSavings: DashboardSavings,
    pxDashboardCompras: DashboardCompras,
    pxIndicadoresComprasHeader: IndicadoresComprasHeader,
    pxDashboardQuantidadeCompras: DashboardQuantidadeCompras,
    pxDashboardTotaisCard: DashboardTotaisCard,
    pxDashboardComprasPorCentroCusto: DashboardComprasPorCentroCusto,
    pxDashboardComprasPorProjeto: DashboardComprasPorProjeto,
    pxIndicadoresListagemCompras: IndicadoresListagemCompras,
  },
  mounted() {
    if (this.$route.hash) {
      const el = document.querySelector(this.$route.hash);
      if (el !== null) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
};
</script>
